import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import PlantModuleNav from "../../../../../components/PlantModuleNav";
import AddBoxIcon from "@mui/icons-material/AddBox";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { changeOrderColumns } from "./columns";
import { lightTable } from "../../../../../styles/muiProps";
import { useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { secondAxios } from "../../../../../api/axios";
import { updateCO } from "./api";
import ChangeOrderTable from "./ChangeOrderTable";
import useDocumentTitle from "../../../../../hooks/useDocumentTitle";
import DownloadablePage from "../../../../../components/DownloadablePage";
import PageHeader from "../../../../../components/PageHeader";

export default function CMSPage() {
  useDocumentTitle("CMS");
  const { plantId } = useParams();

  const [tableData, setTableData] = useState([]);
  const [plant, setPlant] = useState({});

  async function getCOs() {
    const res = await secondAxios.get(`/change-order/plant/${plantId}`);
    setTableData(res?.data || []);
  }

  const getPlant = async () => {
    const res = await secondAxios.get(`/plant/${plantId}`);
    setPlant(res?.data || {});
  };
  useEffect(() => {
    getCOs();
    getPlant();
  }, []);

  return (
    <DownloadablePage fileName="ChinookDT-CMS.pdf">
      <Box sx={{ p: 2, pt: 0 }}>
        <PageHeader
          plant={{ id: plantId, ...plant }}
          pageTitle="CMS (Change Management System)"
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
          }}
        >
          <Button
            // onClick={handleAddRow}
            className="no-export"
            variant="contained"
            startIcon={<AddBoxIcon />}
          >
            Add New
          </Button>
        </Box>

        <div style={{ marginTop: "5px" }}>
          <ChangeOrderTable coTableData={tableData} />
        </div>
      </Box>
    </DownloadablePage>
  );
}
